// extracted by mini-css-extract-plugin
export default {"input":"IdleStage_input__IbU+y","bottom":"IdleStage_bottom__giYID"};